import styled from 'styled-components'

const ServiceInformation = styled.div`
  b {
    font-weight: 600;
  }

  p + p {
    margin-top: 10px;
  }

  p + ol,
  p + ul {
    margin-top: 4px;
  }

  ul,
  ol {
    padding-left: 16px;
    margin-top: 10px;
    margin-bottom: 11px;

    li + li {
      margin-top: 5px;
    }
  }

  ul {
    list-style: disc;
  }

  ol {
    list-style: decimal;
  }
`

export { ServiceInformation } // eslint-disable-line
